.root {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--mantine-color-gray-2);
  background-color: var(--mantine-color-white);
  border-radius: 999px;
  padding: 4px 8px;
  font-size: var(--mantine-font-size-sm);
}

.item {
  display: inline-flex;
  align-items: center;
}

.separator {
  width: 1px;
  height: 16px;
  background-color: var(--mantine-color-gray-4);
  margin: 0 8px;
}
